import {
  FETCH_DASHBOARD_STARTED,
  FETCH_DASHBOARD_COMPLETED,
  FETCH_DASHBOARD_ERROR,
  ADD_DASHBOARD_COUNT_STARTED,
  ADD_DASHBOARD_COUNT_COMPLETED,
  ADD_DASHBOARD_COUNT_ERROR,
  REMOVE_DASHBOARD_COUNT_STARTED,
  REMOVE_DASHBOARD_COUNT_COMPLETED,
  REMOVE_DASHBOARD_COUNT_ERROR
} from '../actionTypes/dashboardActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  dashboards: {}
};

function agentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_DASHBOARD_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_DASHBOARD_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          dashboards: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_DASHBOARD_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case ADD_DASHBOARD_COUNT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_DASHBOARD_COUNT_COMPLETED: {
      let payLoadKey = Object.keys(action.payLoad)[0];
      let payLoadValue = action.payLoad[payLoadKey];
      Object.keys(state.dashboards).map((key) => {
        state.dashboards[key][payLoadKey] = payLoadValue;
      });
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_DASHBOARD_COUNT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case REMOVE_DASHBOARD_COUNT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case REMOVE_DASHBOARD_COUNT_COMPLETED: {
      let payLoadKey = Object.keys(action.payLoad)[0];
      let payLoadValue = action.payLoad[payLoadKey];
      Object.keys(state.dashboards).map((key) => {
        state.dashboards[key][payLoadKey] = payLoadValue;
      });
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case REMOVE_DASHBOARD_COUNT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    default:
      return state;
  }
}

export default agentReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/dashboardReducer.js